import styled from 'styled-components'

export const EmptyTablePlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  height: 100%;

  padding: 30px;
  border-radius: 15px;
  border: 1px solid ${({ theme }) => theme.colors.secondary}50;
`

export const EmptyTablePlaceholderImage = styled.div`
  display: flex;
  justify-content: center;
  width: 200px;
`

export const EmptyTablePlaceholderTextWrapper = styled.div`
  width: 100%;

  // Themed Properties
  color: ${({ theme }) => theme.colors.primary};
`

export const EmptyTablePlaceholderText = styled.div`
  font-size: 20px;
  font-weight: 600;

  text-align: center;
`

export const EmptyTablePlaceholderSubText = styled.div`
  font-size: 16px;
  font-weight: 400;

  text-align: center;
`
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 30px;
`
